<template>
  <div class="fullwidth black">
    <div class="dialog-like sg-dialog">
      <div class="flex-broom">
          <div class="flexb-lpan" v-if="!submitted">
            <div class="title" style="margin-bottom:20px;"><logo-button :width="185" /></div>
            <div class="title brown">{{ $nippets.takeAMinute }}</div>
            <div class="title" style="margin-bottom:20px;">{{ $nippets.createYourFree }}</div>
            <div class="message">
              <div class="signin">
                <div>
                  <input type="text" v-model="fullname" name="fullname" :placeholder="getPlaceholder('fullname')" />
                </div>
                <div>
                  <input type="text" v-model="company" name="company" :placeholder="getPlaceholder('company')" />
                </div>
                <div>
                  <input type="email" v-model="email" name="email" :placeholder="getPlaceholder('email')" />
                </div>
                <div>
                  <input type="password" name="password" v-model="password" :placeholder="getPlaceholder('password')" />
                </div>
                <div>
                  <input type="password"  v-model="passwordRepeat" name="passwordRepeat" :placeholder="getPlaceholder('repeatPassword')" />
                </div>
                <div class="right-button-panel">
                  *{{ $nippets.myarea.required}}
                </div>
                <div class="button-panel">
                  <small-button v-on:click="handleSignup" large :loading="loading">{{ $nippets.signup }}</small-button>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-lb-pan" v-if="submitted">
            <div class="title" style="margin-bottom:20px;"><logo-button :width="185" /></div>
            <div class="title brown">Thank you</div>
            <div class="message">
              <p>
                An email is on its way to you now.
              </p>
            </div>
          </div>
          <div class="login-right-panel flex-between" v-if="!submitted">
            <div class="weird-flex">
              <div>
                {{ $nippets.myarea.haveAccount }}
              </div>
              <div class="but-marg">
                <small-button large v-on:click="showLogin">{{ $nippets.login }}</small-button>
              </div>
            </div>
            <div>
              {{ $nippets.myarea.neverShare }}
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import ah from '@/auth-handler.js'
import LogoButton from '@/components/buttons/LogoButton.vue'
import '@/css/my-area.css'

export default {
  components: {
    LogoButton
  },
  data () {
    return {
      fullname: '',
      company: '',
      email: '',
      password: '',
      passwordRepeat: '',
      loading: false,
      submitted: false
    }
  },
  methods: {
    getPlaceholder(itemname){
      return this.$nippets.myarea[itemname] + '*'
    },
    async handleSignup() {
      let res = this.verifyForm()
      if(res) {
        this.$k.messageBox(this.$nippets.signup, res)
        return
      }
      try {
        this.loading = true
        const Auth = await ah.getAuth()
        let res = await Auth.signUp({ 
          username: this.email, 
          password: this.password,
          attributes: {
            email: this.email
          }
        })
        //todo: other attributes need to be captured in dynamodb
        res = await this.$apix.post('collections/user/signup', { email: this.email, 
          username: this.email, company: this.company, 
          fullname: this.fullname, region: this.$store.state.lang })
        this.loading = false
        if(res.data.message !== 'ok'){
          alert(res.data.message)
        }
        localStorage.illuxSignupEmail = this.email
        this.$k.messageBox(this.$nippets.signup, 'You have been sent an email with a confirmation code. Follow the instructions in it to sign in.')
        this.submitted = true
      }
      catch(err) {
        this.loading = false
        if(err.code === 'UsernameExistsException'){
          this.$k.messageBox(`We're sorry`, 'That email address is already in use - please log in instead of signing up.')
        }
        else {
          this.$k.messageBox(this.$nippets.signup, err.message)
        }
        
      }
    },
    showLogin() {
      this.$store.commit('showLogin')
    },
    verifyForm() {
      if(this.fullname.length < 3) {
        return 'Please supply your full name'
      }
      if(this.company.length < 1) {
        return 'Please supply a company name'
      }
      if(this.password !== this.passwordRepeat){
        return 'The two passwords must match.'
      }
      if(!this.$k.validEmail(this.email)) {
        return this.$nippets.invalidEmail
      }
      if(this.password.length < 8) {
        return 'Password must be at least 8 characters'
      }
      return null
    }
      
  }
  
}
</script>
<style scoped>
.dialog-like{
  width:90vw;
  max-width: 800px;
  background-color:#e8e8e3;
  z-index:5001;
  padding:25px;
  cursor:default;
  box-sizing: border-box;
  border-radius:6px;
  margin-left:auto;
  margin-right:auto;
  overflow:hidden;
}

.fullwidth.black{
  background-color:#101820;
}

.login-right-panel.flex-between{
  justify-content: space-between;
}

.weird-flex{
  flex-grow: 1;
  display:flex;
  flex-direction: column;
  justify-content: center;
}
</style>
